<template>
  <el-dialog
    title="Sign Here"
    :visible.sync="dialogVisible"
    width="30%"
    v-loading="loading"
  >
    <div class="row">
      <div class="col-12">
        <label> Date </label>
        <el-date-picker
          v-model="date"
          value-format="yyyy-MM-dd"
          format="dd/MM/yyyy"
          type="date"
          class="mr-2 w-100"
          placeholder="Signed at"
        >
        </el-date-picker>
      </div>
      <div class="col-12 mt-3">
        <VueSignaturePad
          ref="signaturePad"
          height="200px"
          id="signature-container"
        />
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">Cancel</el-button>
      <el-button type="primary" @click="save">Save</el-button>
    </span>
  </el-dialog>
</template>
<script>
import VueSignaturePad from "vue-signature-pad";
import axios from "axios";
export default {
  components: {
    VueSignaturePad,
  },
  props: {
    saveUrl: {
      required: true,
      type: String,
    },
    contract: {
      required: true,
      type: Object,
    },
    open: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      date: null,
      dialogVisible: false,
    };
  },
  methods: {
    async save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (!isEmpty) {
        try {
          this.loading = true;
          const res = await axios.put(this.saveUrl, {
            signature: data,
            date: this.date,
          });
          console.log(res);
          this.loading = false;
          location.reload();
        } catch (err) {
          this.loading = false;
          this.$message({
            type: "error",
            message: "Error Signing",
          });
          console.error(err);
        }
      }
    },
  },
  watch: {
    open(to, from) {
      this.dialogVisible = to;
    },
    dialogVisible(to, from) {
      this.$emit("update:open", to);
    },
  },
};
</script>
<style lang="scss">
#signature-container {
  border: 1px solid #efefef;
  border-radius: 5px;
}
</style>